// Cost Plus Drugs (costplusdrugs.com) price list — approximate 30-day supply
// Prices: drug cost + 15% markup + $3 dispensing fee
// Updated: April 2026. Refresh quarterly.
// Only generics are carried by Cost Plus Drugs.

const DRUG_LIST = [
  // ── Diabetes ──────────────────────────────────────────────────────────────
  { name: 'Metformin',          generic: 'metformin',          price: 5.40,  category: 'Diabetes' },
  { name: 'Metformin ER',       generic: 'metformin er',       price: 9.90,  category: 'Diabetes' },
  { name: 'Glipizide',          generic: 'glipizide',          price: 5.40,  category: 'Diabetes' },
  { name: 'Glimepiride',        generic: 'glimepiride',        price: 6.30,  category: 'Diabetes' },
  { name: 'Pioglitazone',       generic: 'pioglitazone',       price: 8.10,  category: 'Diabetes' },

  // ── Blood Pressure / Heart ────────────────────────────────────────────────
  { name: 'Lisinopril',         generic: 'lisinopril',         price: 5.40,  category: 'Blood Pressure' },
  { name: 'Amlodipine',         generic: 'amlodipine',         price: 6.30,  category: 'Blood Pressure' },
  { name: 'Losartan',           generic: 'losartan',           price: 8.10,  category: 'Blood Pressure' },
  { name: 'Metoprolol',         generic: 'metoprolol',         price: 5.40,  category: 'Blood Pressure' },
  { name: 'Carvedilol',         generic: 'carvedilol',         price: 5.40,  category: 'Blood Pressure' },
  { name: 'Hydrochlorothiazide',generic: 'hydrochlorothiazide',price: 4.50,  category: 'Blood Pressure' },
  { name: 'HCTZ',               generic: 'hydrochlorothiazide',price: 4.50,  category: 'Blood Pressure' },
  { name: 'Furosemide',         generic: 'furosemide',         price: 4.50,  category: 'Blood Pressure' },
  { name: 'Valsartan',          generic: 'valsartan',          price: 9.90,  category: 'Blood Pressure' },
  { name: 'Clonidine',          generic: 'clonidine',          price: 6.30,  category: 'Blood Pressure' },
  { name: 'Spironolactone',     generic: 'spironolactone',     price: 8.10,  category: 'Blood Pressure' },
  { name: 'Hydralazine',        generic: 'hydralazine',        price: 5.40,  category: 'Blood Pressure' },
  { name: 'Atenolol',           generic: 'atenolol',           price: 5.40,  category: 'Blood Pressure' },

  // ── Cholesterol ───────────────────────────────────────────────────────────
  { name: 'Atorvastatin',       generic: 'atorvastatin',       price: 6.30,  category: 'Cholesterol' },
  { name: 'Simvastatin',        generic: 'simvastatin',        price: 5.40,  category: 'Cholesterol' },
  { name: 'Rosuvastatin',       generic: 'rosuvastatin',       price: 8.10,  category: 'Cholesterol' },
  { name: 'Pravastatin',        generic: 'pravastatin',        price: 6.30,  category: 'Cholesterol' },
  { name: 'Lovastatin',         generic: 'lovastatin',         price: 5.40,  category: 'Cholesterol' },
  { name: 'Ezetimibe',          generic: 'ezetimibe',          price: 10.80, category: 'Cholesterol' },
  { name: 'Fenofibrate',        generic: 'fenofibrate',        price: 9.90,  category: 'Cholesterol' },

  // ── Mental Health / Psychiatry ────────────────────────────────────────────
  { name: 'Sertraline',         generic: 'sertraline',         price: 8.10,  category: 'Mental Health' },
  { name: 'Zoloft',             generic: 'sertraline',         price: 8.10,  category: 'Mental Health' },
  { name: 'Fluoxetine',         generic: 'fluoxetine',         price: 6.30,  category: 'Mental Health' },
  { name: 'Prozac',             generic: 'fluoxetine',         price: 6.30,  category: 'Mental Health' },
  { name: 'Escitalopram',       generic: 'escitalopram',       price: 8.10,  category: 'Mental Health' },
  { name: 'Lexapro',            generic: 'escitalopram',       price: 8.10,  category: 'Mental Health' },
  { name: 'Citalopram',         generic: 'citalopram',         price: 8.10,  category: 'Mental Health' },
  { name: 'Bupropion',          generic: 'bupropion',          price: 12.60, category: 'Mental Health' },
  { name: 'Wellbutrin',         generic: 'bupropion',          price: 12.60, category: 'Mental Health' },
  { name: 'Duloxetine',         generic: 'duloxetine',         price: 9.90,  category: 'Mental Health' },
  { name: 'Cymbalta',           generic: 'duloxetine',         price: 9.90,  category: 'Mental Health' },
  { name: 'Venlafaxine',        generic: 'venlafaxine',        price: 9.90,  category: 'Mental Health' },
  { name: 'Trazodone',          generic: 'trazodone',          price: 6.30,  category: 'Mental Health' },
  { name: 'Mirtazapine',        generic: 'mirtazapine',        price: 8.10,  category: 'Mental Health' },
  { name: 'Quetiapine',         generic: 'quetiapine',         price: 9.90,  category: 'Mental Health' },
  { name: 'Seroquel',           generic: 'quetiapine',         price: 9.90,  category: 'Mental Health' },
  { name: 'Aripiprazole',       generic: 'aripiprazole',       price: 12.60, category: 'Mental Health' },
  { name: 'Clonazepam',         generic: 'clonazepam',         price: 8.10,  category: 'Mental Health' },
  { name: 'Klonopin',           generic: 'clonazepam',         price: 8.10,  category: 'Mental Health' },
  { name: 'Alprazolam',         generic: 'alprazolam',         price: 8.10,  category: 'Mental Health' },
  { name: 'Xanax',              generic: 'alprazolam',         price: 8.10,  category: 'Mental Health' },
  { name: 'Lorazepam',          generic: 'lorazepam',          price: 7.20,  category: 'Mental Health' },
  { name: 'Buspirone',          generic: 'buspirone',          price: 6.30,  category: 'Mental Health' },
  { name: 'Hydroxyzine',        generic: 'hydroxyzine',        price: 6.30,  category: 'Mental Health' },

  // ── ADHD ─────────────────────────────────────────────────────────────────
  { name: 'Methylphenidate',    generic: 'methylphenidate',    price: 9.90,  category: 'ADHD' },
  { name: 'Ritalin',            generic: 'methylphenidate',    price: 9.90,  category: 'ADHD' },
  { name: 'Amphetamine salts',  generic: 'amphetamine salts',  price: 32.40, category: 'ADHD' },
  { name: 'Adderall',           generic: 'amphetamine salts',  price: 32.40, category: 'ADHD' },
  { name: 'Atomoxetine',        generic: 'atomoxetine',        price: 28.80, category: 'ADHD' },

  // ── Thyroid ───────────────────────────────────────────────────────────────
  { name: 'Levothyroxine',      generic: 'levothyroxine',      price: 6.30,  category: 'Thyroid' },
  { name: 'Synthroid',          generic: 'levothyroxine',      price: 6.30,  category: 'Thyroid' },
  { name: 'Methimazole',        generic: 'methimazole',        price: 7.20,  category: 'Thyroid' },

  // ── Stomach / GI ─────────────────────────────────────────────────────────
  { name: 'Omeprazole',         generic: 'omeprazole',         price: 6.30,  category: 'GI' },
  { name: 'Prilosec',           generic: 'omeprazole',         price: 6.30,  category: 'GI' },
  { name: 'Pantoprazole',       generic: 'pantoprazole',       price: 8.10,  category: 'GI' },
  { name: 'Protonix',           generic: 'pantoprazole',       price: 8.10,  category: 'GI' },
  { name: 'Famotidine',         generic: 'famotidine',         price: 5.40,  category: 'GI' },
  { name: 'Pepcid',             generic: 'famotidine',         price: 5.40,  category: 'GI' },
  { name: 'Ondansetron',        generic: 'ondansetron',        price: 9.00,  category: 'GI' },
  { name: 'Zofran',             generic: 'ondansetron',        price: 9.00,  category: 'GI' },

  // ── Pain / Inflammation ───────────────────────────────────────────────────
  { name: 'Meloxicam',          generic: 'meloxicam',          price: 8.10,  category: 'Pain' },
  { name: 'Cyclobenzaprine',    generic: 'cyclobenzaprine',    price: 6.30,  category: 'Pain' },
  { name: 'Flexeril',           generic: 'cyclobenzaprine',    price: 6.30,  category: 'Pain' },
  { name: 'Gabapentin',         generic: 'gabapentin',         price: 8.10,  category: 'Pain' },
  { name: 'Neurontin',          generic: 'gabapentin',         price: 8.10,  category: 'Pain' },
  { name: 'Pregabalin',         generic: 'pregabalin',         price: 18.90, category: 'Pain' },
  { name: 'Prednisone',         generic: 'prednisone',         price: 6.30,  category: 'Pain' },
  { name: 'Naproxen',           generic: 'naproxen',           price: 5.40,  category: 'Pain' },
  { name: 'Tramadol',           generic: 'tramadol',           price: 8.10,  category: 'Pain' },

  // ── Respiratory / Allergy ─────────────────────────────────────────────────
  { name: 'Albuterol',          generic: 'albuterol',          price: 26.90, category: 'Respiratory' },
  { name: 'ProAir',             generic: 'albuterol',          price: 26.90, category: 'Respiratory' },
  { name: 'Montelukast',        generic: 'montelukast',        price: 10.80, category: 'Respiratory' },
  { name: 'Singulair',          generic: 'montelukast',        price: 10.80, category: 'Respiratory' },
  { name: 'Fluticasone nasal',  generic: 'fluticasone nasal',  price: 18.90, category: 'Respiratory' },
  { name: 'Flonase',            generic: 'fluticasone nasal',  price: 18.90, category: 'Respiratory' },
  { name: 'Cetirizine',         generic: 'cetirizine',         price: 4.50,  category: 'Allergy' },
  { name: 'Zyrtec',             generic: 'cetirizine',         price: 4.50,  category: 'Allergy' },
  { name: 'Loratadine',         generic: 'loratadine',         price: 3.60,  category: 'Allergy' },
  { name: 'Claritin',           generic: 'loratadine',         price: 3.60,  category: 'Allergy' },
  { name: 'Fexofenadine',       generic: 'fexofenadine',       price: 6.30,  category: 'Allergy' },
  { name: 'Allegra',            generic: 'fexofenadine',       price: 6.30,  category: 'Allergy' },

  // ── Antibiotics ───────────────────────────────────────────────────────────
  { name: 'Amoxicillin',        generic: 'amoxicillin',        price: 5.40,  category: 'Antibiotics' },
  { name: 'Azithromycin',       generic: 'azithromycin',       price: 9.00,  category: 'Antibiotics' },
  { name: 'Doxycycline',        generic: 'doxycycline',        price: 8.10,  category: 'Antibiotics' },
  { name: 'Ciprofloxacin',      generic: 'ciprofloxacin',      price: 9.00,  category: 'Antibiotics' },

  // ── Sleep ─────────────────────────────────────────────────────────────────
  { name: 'Zolpidem',           generic: 'zolpidem',           price: 8.10,  category: 'Sleep' },
  { name: 'Ambien',             generic: 'zolpidem',           price: 8.10,  category: 'Sleep' },

  // ── Urological / Men's Health ─────────────────────────────────────────────
  { name: 'Tamsulosin',         generic: 'tamsulosin',         price: 9.90,  category: 'Urology' },
  { name: 'Flomax',             generic: 'tamsulosin',         price: 9.90,  category: 'Urology' },
  { name: 'Finasteride',        generic: 'finasteride',        price: 9.00,  category: 'Urology' },
  { name: 'Propecia',           generic: 'finasteride',        price: 9.00,  category: 'Urology' },
  { name: 'Sildenafil',         generic: 'sildenafil',         price: 18.90, category: 'Urology' },
  { name: 'Viagra',             generic: 'sildenafil',         price: 18.90, category: 'Urology' },
  { name: 'Tadalafil',          generic: 'tadalafil',          price: 22.50, category: 'Urology' },
  { name: 'Cialis',             generic: 'tadalafil',          price: 22.50, category: 'Urology' },

  // ── Blood Thinners ────────────────────────────────────────────────────────
  { name: 'Warfarin',           generic: 'warfarin',           price: 5.40,  category: 'Cardiology' },
  { name: 'Coumadin',           generic: 'warfarin',           price: 5.40,  category: 'Cardiology' },
  { name: 'Clopidogrel',        generic: 'clopidogrel',        price: 8.10,  category: 'Cardiology' },
  { name: 'Plavix',             generic: 'clopidogrel',        price: 8.10,  category: 'Cardiology' },

  // ── Women's Health ────────────────────────────────────────────────────────
  { name: 'Estradiol',          generic: 'estradiol',          price: 8.10,  category: "Women's Health" },
  { name: 'Progesterone',       generic: 'progesterone',       price: 12.60, category: "Women's Health" },
  { name: 'Norethindrone',      generic: 'norethindrone',      price: 8.10,  category: "Women's Health" },
];

// Build a lookup map keyed by lowercase name for fast matching
const LOOKUP = {};
for (const drug of DRUG_LIST) {
  LOOKUP[drug.name.toLowerCase()] = drug;
  LOOKUP[drug.generic.toLowerCase()] = drug;
}

/**
 * Look up a medication by name (case-insensitive, matches brand or generic).
 * Returns { name, price, category } or null.
 */
export function lookupDrug(medicationName) {
  if (!medicationName) return null;
  const key = medicationName.trim().toLowerCase();
  if (LOOKUP[key]) return LOOKUP[key];
  // Partial match — find first drug whose name starts with the query
  for (const drug of DRUG_LIST) {
    if (drug.name.toLowerCase().startsWith(key) || drug.generic.toLowerCase().startsWith(key)) {
      return drug;
    }
  }
  return null;
}

/**
 * Get autocomplete suggestions for a partial drug name.
 * Returns up to 5 matching drug display names.
 */
export function getSuggestions(query) {
  if (!query || query.length < 2) return [];
  const q = query.trim().toLowerCase();
  const seen = new Set();
  const results = [];
  for (const drug of DRUG_LIST) {
    const key = drug.generic; // dedupe by generic name
    if (seen.has(key)) continue;
    if (drug.name.toLowerCase().startsWith(q) || drug.generic.toLowerCase().startsWith(q)) {
      seen.add(key);
      results.push(drug);
    }
    if (results.length >= 5) break;
  }
  return results;
}

// Rough Rx copay estimates by carrier + plan for generic Tier 1 drugs
// Used to show insurance comparison on medication cards
const RX_ESTIMATES = {
  'bcbs|ppo':   '$5–15/mo',
  'bcbs|hmo':   '$5–10/mo',
  'bcbs|hdhp':  '$5–20 (after deductible)',
  'bcbs|epo':   '$5–10/mo',
  'aetna|ppo':  '$5–15/mo',
  'aetna|hmo':  '$5–10/mo',
  'aetna|hdhp': '$10–20 (after deductible)',
  'aetna|epo':  '$5–15/mo',
  'cigna|ppo':  '$10–20/mo',
  'cigna|hmo':  '$5–15/mo',
  'cigna|hdhp': '$10–25 (after deductible)',
  'cigna|epo':  '$10–20/mo',
  'united|ppo': '$10–25/mo',
  'united|hmo': '$5–15/mo',
  'united|hdhp':'$10–25 (after deductible)',
  'united|epo': '$10–20/mo',
  'humana|ppo': '$5–15/mo',
  'humana|hmo': '$5–10/mo',
  'humana|hdhp':'$5–20 (after deductible)',
  'medicaid':   '$1–3/mo',
  'medicare':   '$5–15/mo',
};

export function getRxEstimate(carrier, planType) {
  if (!carrier) return null;
  const key = planType ? `${carrier}|${planType}` : carrier;
  return RX_ESTIMATES[key] || RX_ESTIMATES[carrier] || null;
}
